export const LandingPics = [
  {
    img: "/landing_carousel/group photo 2024.jpg",
    description: "Xu Lab group photo in 2024"
  },
  {
    img: "/equipments/stream.jpg",
    description: "Lab equipment ScientaOmicron STREAM STM system with a customized preparation chamber."
  },
  {
    img: "/equipments/VT.jpg",
    description: "Lab equipment ScientaOmicron VT-STM system"
  },
  {
    img: "/landing_carousel/Xu_group activity_2025.jpg",
    description: "Group activity of escape the room in 2025"
  },
];